module.exports = "./assets/assets/‭相关政策依据.0b17ac3e.docx";